// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3Tylr","label":"LabeledBox_label___RiQP"};